import { Entity } from "src/app/core/utils/entity";

export abstract class UpdateClaimConciliatorEntity extends Entity {
    constructor(
        public claimId: string,
        public conciliatorId: string
    ){
        super();
    }
}